import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt, FaUsers, FaWhatsapp, FaArrowRight } from "react-icons/fa";

const contactChannels = [
  {
    title: "WhatsApp",
    value: "0753311157",
    href: "https://wa.me/255753311157",
    icon: <FaWhatsapp />,
    color: "#25D366"
  },
  {
    title: "Calls",
    value: "0718034160",
    href: "tel:+255718034160",
    icon: <FaPhoneAlt />,
    color: "#007bff"
  },
  {
    title: "Email",
    value: "info@doublefsmartenergies.com",
    href: "mailto:info@doublefsmartenergies.com",
    icon: <FaEnvelope />,
    color: "#ea4335"
  },
  {
    title: "Address",
    value: "Kijitonyama near Mabatini Police Station",
    href: null,
    icon: <FaMapMarkerAlt />,
    color: "#34a853"
  },
];

const partnershipTracks = [
  "Solar and renewable energy project delivery",
  "Institutional, corporate and government power solutions",
  "Electrical, CCTV and security infrastructure deployment",
  "Maintenance contracts for AC, generators and technical systems",
];

export default function ContactUsContent() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) return <div className="container py-5">{getInlineLoader()}</div>;

  return (
    <section className="MainBodySection py-5 fr-contact-wrap bg-light-subtle overflow-hidden">
      <div className="container">
        {/* Header Section */}
        <div className="text-center mb-5 mx-auto" style={{ maxWidth: "700px" }}>
          <h2 className="display-6 font-bold text-secondary mb-3">Offices & Partnership Desk</h2>
          <p className="text-muted fs-6">
            Reach out to <b>DOUBLE F SMART ENERGIES ENTERPRISE</b> for project consultations, technical support, and partnership opportunities.
          </p>
        </div>

        <div className="row g-4 align-items-stretch">
          {/* Main Contact Grid */}
          <div className="col-lg-7">
            <div className="h-100 rounded-4 bg-white border-0 shadow-sm p-4 p-md-5">
              <h5 className="font-bold text-secondary mb-4 d-flex align-items-center gap-2">
                Official Channels <span className="badge bg-primary text-primary fw-normal small-text">Active</span>
              </h5>
              <div className="row g-3">
                {contactChannels.map((item) => {
                  const Content = (
                    <>
                      <div className="fr-contact-icon-box rounded-3 p-2 d-flex align-items-center justify-content-center mb-2" 
                           style={{ backgroundColor: `${item.color}15`, color: item.color, width: '45px', height: '45px' }}>
                        {item.icon}
                      </div>
                      <div className="w-100 overflow-hidden">
                        <h6 className="fw-bold text-dark mb-1 small tracking-tight">{item.title}</h6>
                        <p className="text-muted font-bold mb-0 text-break" style={{ fontSize: '0.9rem' }}>{item.value}</p>
                      </div>
                    </>
                  );

                  return (
                    <div key={item.title} className="col-sm-6">
                      {item.href ? (
                        <a href={item.href} className="h-100 d-flex flex-column align-items-start rounded-4 border p-3 text-decoration-none transition-all hover-bg-light fr-contact-card">
                          {Content}
                        </a>
                      ) : (
                        <div className="h-100 d-flex flex-column align-items-start rounded-4 border p-3 fr-contact-card">
                          {Content}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Sidebar / Collaboration Panel */}
          <div className="col-lg-5">
            <div className="h-100 rounded-4 p-4 p-md-5 bg-dark text-white shadow-lg d-flex flex-column justify-content-center position-relative overflow-hidden">
              {/* Subtle background decoration */}
              <div className="position-absolute top-0 end-0 p-4 opacity-10">
                <FaUsers size={120} className="opacity-50" />
              </div>

              <div className="position-relative z-1">
                <h4 className="font-bold mb-4 text-primary">Collaboration Areas</h4>
                <div className="d-flex flex-column gap-3 mb-4">
                  {partnershipTracks.map((item) => (
                    <div key={item} className="d-flex align-items-start gap-2">
                      <div className="mt-1 text-primary">🟡</div>
                      <p className="mb-0 font-semi-bold">{item}</p>
                    </div>
                  ))}
                </div>
                <a href="mailto:info@doublefsmartenergies.com" className="btn btn-primary w-100 py-3 fw-bold rounded-pill shadow-sm transition-all hover-up">
                  Connect With Our Team
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}